import { z } from 'zod';

// PASSTHROUGH: fornitore esterno (Stripe) aggiunge campi senza preavviso.
// MAI usare .strict() qui — la libreria Stripe verifica già la firma sul rawBody.
export const stripeWebhookEventSchema = z.object({
  id: z.string().min(1),
  type: z.string().min(1),
  api_version: z.string().optional(),
  created: z.number().optional(),
  livemode: z.boolean().optional(),
  data: z.object({
    object: z.record(z.unknown()),
    previous_attributes: z.record(z.unknown()).optional(),
  }).passthrough(),
  request: z.object({
    id: z.string().nullable().optional(),
    idempotency_key: z.string().nullable().optional(),
  }).passthrough().nullable().optional(),
}).passthrough();

export const stripeCheckoutSessionBodySchema = z.object({
  price_id: z.string().min(1, 'price_id obbligatorio').optional(),
  quantity: z.number().int().min(1).max(1000).optional(),
  success_url: z.string().url('success_url deve essere un URL valido').optional(),
  cancel_url: z.string().url('cancel_url deve essere un URL valido').optional(),
  customer_email: z.string().email().optional(),
  metadata: z.record(z.string()).optional(),
}).passthrough();
